import { Box, Button, Flex, Grid, VStack } from '@chakra-ui/react';
import { Icon } from '@common/components/Icon';
import React from 'react';
import { TextBlock } from 'src/apps/invest/common/components/TextBlock';
import { useSignUpModel } from '../../models/SignUpModel';

export const PartnerAccountForm: React.FC = () => {
  const signUpModel = useSignUpModel();

  return (
    <Flex flexDir={'column'} justifyContent={'space-between'} flex={1} w="full">
      <Flex flexDir={'column'} flex={1}>
        <TextBlock fontSize={'24px'} weight="bold">
          Let's get your account created.
        </TextBlock>
        <TextBlock color="gray.400" fontSize={'24px'} weight="bold">
          Does this info look good?
        </TextBlock>
      </Flex>
      <Flex flexDir={'column'} flex={1} pt="24px">
        <Grid columnGap="32px" gridTemplateColumns={'content 1fr'}>
          {Boolean(signUpModel.email) && (
            <>
              <TextBlock gridColumn={1}>Email</TextBlock>
              <Flex alignItems={'center'}>
                <TextBlock gridColumn={2} weight="bold">
                  {signUpModel.email}
                </TextBlock>
                <Box ml="5px">
                  <Icon
                    fontSize={signUpModel.emailValidationState === 'VALID' ? '13px' : '8px'}
                    color={signUpModel.emailValidationState === 'VALID' ? 'green' : 'red'}
                    icon={signUpModel.emailValidationState === 'VALID' ? 'check' : 'circle'}></Icon>
                </Box>
              </Flex>
            </>
          )}

          {Boolean(signUpModel.firstName) && (
            <>
              <TextBlock gridColumn={1}>First Name:</TextBlock>
              <TextBlock gridColumn={2} weight="bold">
                {signUpModel.firstName}
              </TextBlock>
            </>
          )}
          {Boolean(signUpModel.lastName) && (
            <>
              <TextBlock gridColumn={1}>Last Name</TextBlock>
              <TextBlock gridColumn={2} weight="bold">
                {signUpModel.lastName}
              </TextBlock>
            </>
          )}
          {Boolean(signUpModel.phone) && (
            <>
              <TextBlock gridColumn={1}>Phone</TextBlock>
              <TextBlock gridColumn={2} weight="bold">
                {signUpModel.phone}
              </TextBlock>
            </>
          )}
          {signUpModel.emailValidationState === 'INVALID_FORMAT' && (
            <TextBlock gridColumn="span 2" my="10px" size="14px" color="red">
              This email is invalid. You’ll need to correct it during signup.
            </TextBlock>
          )}
          {signUpModel.emailValidationState === 'UNAVAILABLE' && (
            <TextBlock gridColumn="span 2" my="10px" size="14px" color="red">
              This email is already associated with an existing account. You will be required to use a new email
              address.
            </TextBlock>
          )}
        </Grid>
      </Flex>
      <VStack pt="24px" flex={1} maxW="100%">
        <Button
          h="60px"
          onClick={() => {
            signUpModel.nextScreen({});
          }}
          w="full">
          Yes, create my account
        </Button>
        <Button
          h="60px"
          onClick={() => {
            signUpModel.reset();
          }}
          w="full"
          colorScheme="black"
          variant={'outline'}>
          No, let me fix it
        </Button>
        <Flex w="full" justifyContent={'center'}>
          <Icon boxSize={3} color="gray.300" icon="lock"></Icon>
          <TextBlock color="gray.400" fontSize={'12px'}>
            Your info is secure and will never be shared
          </TextBlock>
        </Flex>
      </VStack>
    </Flex>
  );
};
